import type { AxiosResponse } from 'axios';
import { inject, injectable } from 'inversify';
import { HostDependencyTypes } from '@shared/common/host/host.dependency-types';
import type { HubApiService } from '@shared/common/host/data/service/hub.api-service';
import type { CustomerChatbotVisitorIdentificationApiData } from '@client/feature/customer-chatbots/data/api-data/customer-chatbot-visitor-identification.api-data';
import { CustomerChatbotApiRoute } from '@client/feature/customer-chatbots/data/constant/customer-chatbot.api-routes';

@injectable()
export class CustomerChatbotApiService {
  public constructor(
    @inject(HostDependencyTypes.HubApiService)
    private readonly hubApiService: HubApiService,
  ) {}

  public login(): Promise<AxiosResponse<CustomerChatbotVisitorIdentificationApiData>> {
    return this.hubApiService.post<CustomerChatbotVisitorIdentificationApiData, Record<string, never>>(
      CustomerChatbotApiRoute.Login,
      {},
    );
  }
}
